import {
  lazyVue
} from '@/utils'
export default [
  {
    path: '/my',
    name: 'my',
    title: '我的',
    component: lazyVue('my/index'),
    meta: {
      title: '我的',
      name: 'my',
      showBar: true,
      isKeepAlive: false,
    }
  },
  {
    path: '/myPersonalInfo',
    name: 'myPersonalInfo',
    title: '个人设置',
    component: lazyVue('my/myPersonalInfo/index'),
    meta: {
      title: '个人设置',
      name: 'myPersonalInfo',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myPersonalInfo/nickName',
    name: 'myPersonalInfo/nickName',
    title: '修改昵称',
    component: lazyVue('my/myPersonalInfo/nickName/index'),
    meta: {
      title: '修改昵称',
      name: 'nickName',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myPersonalInfo/changePhone',
    name: 'myPersonalInfo/changePhone',
    title: '验证当前手机',
    component: lazyVue('my/myPersonalInfo/bindPhone/index'),
    meta: {
      title: '验证当前手机',
      name: 'changePhone',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myPersonalInfo/bindPhone',
    name: 'myPersonalInfo/bindPhone',
    title: '更换绑定手机',
    component: lazyVue('my/myPersonalInfo/bindPhone/next'),
    meta: {
      title: '更换绑定手机',
      name: 'bindPhone',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myPersonalInfo/password',
    name: 'myPersonalInfo/password',
    title: '修改密码',
    component: lazyVue('my/myPersonalInfo/password/index'),
    meta: {
      title: '修改密码',
      name: 'password',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myCollection',
    name: 'myCollection',
    title: '我的收藏',
    component: lazyVue('my/myCollection/index'),
    meta: {
      title: '我的收藏',
      name: 'myCollection',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/about',
    name: 'about',
    title: '关于我们',
    component: lazyVue('my/about/index'),
    meta: {
      title: '关于我们',
      name: 'about',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/serviceAddress',
    name: 'serviceAddress',
    title: '服务地址',
    component: lazyVue('serviceAddress/index'),
    meta: {
      title: '服务地址',
      name: 'serviceAddress',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/serviceAddressItem',
    name: 'serviceAddressItem',
    title: '服务地址',
    component: lazyVue('serviceAddress/item'),
    meta: {
      title: '服务地址',
      name: 'serviceAddressItem',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myEditUserName',
    name: 'myEditUserName',
    title: '修改昵称',
    component: lazyVue('my/myEditUserName/index'),
    meta: {
      title: '修改昵称',
      name: 'myEditUserName',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myFeedback',
    name: 'myFeedback',
    title: '意见反馈',
    component: lazyVue('my/myFeedback/index'),
    meta: {
      title: '意见反馈',
      name: 'myFeedback',
      showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/myResidentMember',
    name: 'myResidentMember',
    title: '我的院民会员',
    component: lazyVue('my/myResidentMember/index'),
    meta: {
      title: '我的院民会员',
      name: 'myResidentMember',
      // showBar: false,
      isKeepAlive: false,
    }
  },
  {
    path: '/accountDetail',
    name: 'accountDetail',
    title: '账号明细',
    component: lazyVue('my/accountDetail/index'),
    meta: {
      title: '账号明细',
      name: 'accountDetail',
      // showBar: false,
      // isKeepAlive: false,
    }
  },
  {
    path: '/myFamilycardList',
    name: 'myFamilycardList',
    title: '我的家人',
    component: lazyVue('my/myFamilycardList/index'),
    meta: {
      title: '我的家人',
      name: 'myFamilycardList',
      // showBar: false,
      // isKeepAlive: false,
    }
  },
  {
    path: '/myFamilycardInfo',
    name: 'myFamilycardInfo',
    title: '亲属卡详情',
    component: lazyVue('my/myFamilycardInfo/index'),
    meta: {
      title: '亲属卡详情',
      name: 'myFamilycardInfo',
      // showBar: false,
      // isKeepAlive: false,
    }
  },
  {
    path: '/myFamilyInfo',
    name: 'myFamilyInfo',
    title: '我的家属信息',
    component: lazyVue('my/myFamilyInfo/index'),
    meta: {
      title: '我的家属信息',
      name: 'myFamilyInfo',
      // showBar: false,
      // isKeepAlive: false,
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/my/index.js